import { useQuery } from "react-query";
import { getProdFranchiseTypes } from "../../../../actions/CarrierAgreementMgmt/ProducerCodeConfig";

export const useProdFranchiseType = () => {
  return useQuery("GetProducerFranchiseTypes", getProdFranchiseTypes, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
};
